<template>
  <div class="WhatWeDoItemContainer bothCenter"
    :style="{backgroundImage:`url(${data.icon})`}">
    <div class="coverMsg bothCenter">
      <span>请点击</span>
    </div>
    <div class="coverText bothCenter">
      <span>{{data.title}}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "WhatWeDoItemNew",
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          icon: 'https://cdn.waityou.online/6137ea4c-d23a-6dc0-371d-a3b7d28d885e.png',
        }
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.WhatWeDoItemContainer {
  display: flex;
  flex-direction: column;
  height: 98px;
  width: 100%;
  border-radius: 16px;
  background-size: cover;
  background-repeat: no-repeat;background-size: 100% 100%;
  position: relative;

  .title {
    padding: 4px 0;
  }

  img {
    height: 115px;
    width: 115px;
  }
  .coverMsg{
    position: absolute;
    font-size: $minFontSize;
    color: #fff;
    height: 35%;
    bottom: 23px;
    left: 7%;
    white-space: nowrap;
  }
  .coverText {
    position: absolute;
    font-weight: bold;
    font-size: $miniFontSize;
    color: #fff;
    // width: 40%;
    height: 22%;
    bottom: 13px;
    left: 7%;
    white-space: nowrap;
  }

  .subTitle {
    font-size: $miniFontSize;
    color: #999999;
  }
}
</style>